import React from "react";
import "./styles/About.scss";

const About = () => {
  return (
    <div className="section">
      <div className="section__container">
        <div className="section__content">
          <h1>About Me</h1>
          <p>
            Hello! My name is Mpese and I enjoy creating things that live on the
            internet.Learning new skills daily, and stay connected, and involved
            with my fellow developers.{" "}
          </p>
          <p>
            My interest in web development started back in 2018 when I decided
            to try to build a simple Website - taught me a lot about HTML & CSS!
          </p>
          <p>
            I'm also proud of my ability to preserve and overcome any challenges
            as they come up.I've worked hard in my education and now I'm ready
            to apply my knowledge into practice.{" "}
          </p>
          <p>
            My goal is to gain enough experience in web development and building
            tools to help businesses grow.
          </p>
          <p>
            He spends his free time reading, cooking, and going on travel
            adventures whenever he is not making content or writing code.
          </p>
    
          

<div    className="colz">
  <h3>Here are few technologies I've been working with: </h3>

  <ul>
            <li>HTML </li>
            <li>CSS</li>
            <li>JavaScript</li>
             <li>React.js</li>
              <li>SQL</li>
               <li>Node.js</li>
          </ul>
</div>
   
         
        </div>
      </div>
    </div>
  );
};

export default About;
